import React from 'react';
import { twMerge } from 'tailwind-merge';

export default function Loading({ msg, className }) {
  return (
    <>
      <div
        className={twMerge([
          'w-full h-full flex justify-center items-center text-2xl my-24 font-bold',
          className,
        ])}
      >
        <span className="loading loading-spinner w-12 text-info mr-3"></span>
        {msg ?? 'Wczytywanie'}
      </div>
    </>
  );
}
